import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  makeStyles
} from '@material-ui/core';
import React from 'react';
import { FormControl } from 'react-bootstrap';
import CloseIcon from '@material-ui/icons/Close';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import CommonButton from '../atoms/CommonButton';

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  },
  headerContainer: {
    fontSize: 23,
    color: '#fff',
    fontWeight: 500,
    backgroundColor: '#9A9A9A',
    textAlign: 'center',
    padding: 20
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 0
  },
  textMonth: {
    fontSize: 23,
    color: '#fff',
    fontWeight: 500
  },
  rowPadding: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    display: 'flex',
    flexDirection: 'row'
  },
  alignSelfCenter: {
    alignSelf: 'center'
  },
  input: {
    width: 80,
    textAlign: 'right',
    minHeight: 40
  },
  column: {
    paddingRight: 0,
    paddingLeft: 0,
    textAlign: 'right',
    alignSelf: 'center'
  },
  budgetAlertTextBox: {
    color: '#FF3939',
    fontSize: 12,
    backgroundColor: '#FFFAC9',
    padding: 20,
    marginTop: 10,
    marginBottom: 10
  },
  dialogAction: {
    marginBottom: 20,
    justifyContent: 'center'
  },
  row: {
    padding: 20,
    paddingLeft: 25,
    paddingRight: 25
  },
  col1: {
    alignSelf: 'center'
  },
  col2: {
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'right',
    alignSelf: 'center'
  },
  formControl: {
    minHeight: 40,
    borderRadius: 4,
    borderColor: '#ccc',
    fontSize: 16,
    textAlign: 'right',
    width: '100%',
    boxShadow: 'none'
  },
  alertTextBox: {
    color: '#FF3939',
    fontSize: 12,
    backgroundColor: '#FFFAC9',
    padding: 20,
    marginTop: 10,
    marginBottom: 10
  },
  dialogRoot: {
    fontWeight: 'bold'
  }
});

const Main = enhance(
  ({
    budgetRowDetail,
    budgetAmount,
    cancelAction,
    isOpen,
    okAction,
    setBudgetAmount
  }) => {
    function monthToStr(m) {
      return m < 10 ? `0${m}` : m;
    }
    const classes = useStyles();
    const sumBudget =
      Number(budgetRowDetail && budgetRowDetail.budgetAmount) +
      Number(budgetAmount);
    const oldBudget = (budgetRowDetail && budgetRowDetail.budgetAmount) || 0;
    const month = budgetRowDetail && budgetRowDetail.budgetMonth;
    return (
      <Dialog
        open={isOpen}
        onClose={cancelAction}
        className={classes.dialogRoot}
      >
        <div className={classes.headerContainer}>
          <IconButton
            aria-label="close"
            onClick={cancelAction}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
          <div className={classes.textMonth}>
            {`{${monthToStr(month)}月}`}
            予算修正
          </div>
        </div>
        <DialogContent>
          <Grid container className={classes.row}>
            <Grid xs={6} className={classes.col1}>
              承認済み金額
            </Grid>
            <Grid xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid xs={5}>{`{${oldBudget.toLocaleString()}}`}</Grid>
          </Grid>
          <Grid container className={classes.row}>
            <Grid xs={6} className={classes.col1}>
              追加希望金額
            </Grid>
            <Grid xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid xs={5}>
              <FormControl
                type="text"
                className={classes.formControl}
                value={budgetAmount}
                onChange={e => {
                  const value =
                    parseInt(e.target.value.replace(/[^\d]/, ''), 0) || '';

                  if (value > 100000000) {
                    alert('予算の上限額を超えました。やり直してください。');
                  } else {
                    setBudgetAmount(value);
                  }
                }}
              />
            </Grid>
          </Grid>

          <hr />

          <Grid container className={classes.row}>
            <Grid xs={6} className={classes.col1}>
              追加後金額
            </Grid>
            <Grid xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid xs={5}>{`{${sumBudget.toLocaleString()}}`}</Grid>
          </Grid>

          <div className={classes.alertTextBox}>
            ※すでに承認された金額を減額することはできません
            <br />
            ※申請後承認されるとチケット利用が可能です
            <br />
            ※毎月月末14時以降の申請は受け付けができませんのでご注意ください
          </div>
        </DialogContent>
        <DialogActions>
          <CommonButton
            disabled={budgetAmount === ''}
            title="申請する"
            onClickAction={() => okAction(budgetAmount)}
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(Main);
